import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ShrinkSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#343330",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20.031 5.03104L15.3107 9.75042H18.0004C18.1993 9.75042 18.3901 9.82943 18.5307 9.97009C18.6714 10.1107 18.7504 10.3015 18.7504 10.5004C18.7504 10.6993 18.6714 10.8901 18.5307 11.0307C18.3901 11.1714 18.1993 11.2504 18.0004 11.2504H13.5004C13.3015 11.2504 13.1107 11.1714 12.9701 11.0307C12.8294 10.8901 12.7504 10.6993 12.7504 10.5004V6.00042C12.7504 5.8015 12.8294 5.61074 12.9701 5.47009C13.1107 5.32943 13.3015 5.25042 13.5004 5.25042C13.6993 5.25042 13.8901 5.32943 14.0307 5.47009C14.1714 5.61074 14.2504 5.8015 14.2504 6.00042V8.6901L18.9698 3.96979C19.1105 3.82906 19.3014 3.75 19.5004 3.75C19.6994 3.75 19.8903 3.82906 20.031 3.96979C20.1718 4.11052 20.2508 4.30139 20.2508 4.50042C20.2508 4.69944 20.1718 4.89031 20.031 5.03104ZM10.5004 12.7504H6.00042C5.8015 12.7504 5.61074 12.8294 5.47009 12.9701C5.32943 13.1107 5.25042 13.3015 5.25042 13.5004C5.25042 13.6993 5.32943 13.8901 5.47009 14.0307C5.61074 14.1714 5.8015 14.2504 6.00042 14.2504H8.6901L3.96979 18.9698C3.82906 19.1105 3.75 19.3014 3.75 19.5004C3.75 19.6994 3.82906 19.8903 3.96979 20.031C4.11052 20.1718 4.30139 20.2508 4.50042 20.2508C4.69944 20.2508 4.89031 20.1718 5.03104 20.031L9.75042 15.3107V18.0004C9.75042 18.1993 9.82943 18.3901 9.97009 18.5307C10.1107 18.6714 10.3015 18.7504 10.5004 18.7504C10.6993 18.7504 10.8901 18.6714 11.0307 18.5307C11.1714 18.3901 11.2504 18.1993 11.2504 18.0004V13.5004C11.2504 13.3015 11.1714 13.1107 11.0307 12.9701C10.8901 12.8294 10.6993 12.7504 10.5004 12.7504Z"
        fill={color}
      />
    </svg>
  );
};

export { ShrinkSvg };
